import moment from 'moment-timezone';

import DatePicker from 'vue2-datepicker';

import projectHeader from '@/components/project/detail/projectHeader/index.vue';
import projectFileUpload from '@/components/project/detail/fileUpload/index.vue';

import preloader from '@/components/preloader/index.vue';
import rating from '@/components/rating/index.vue';
import pagination from '@/components/pagination/index.vue';

import helpers from '@/mixins/helpers';

import Api from '@/utils/api';

import {
  ROLE_PROJECT_MNG,
  ROLE_QA_EXPERT,
  ROLE_PROOF_READER,
  DEFAULT_IMAGE,
  ROLE_SYSTEM_ADMIN,
} from '@/utils/const';

export default {
  components: {
    DatePicker,
    projectHeader,
    projectFileUpload,
    preloader,
    rating,
    pagination,
  },
  mixins: [
    helpers.work_with_string,
    helpers.general,
  ],
  data () {
    return {
      userImage: DEFAULT_IMAGE,

      responseData: [],

      roleProjectMng: ROLE_PROJECT_MNG,
      roleQaExpert: ROLE_QA_EXPERT,
      roleProofReader: ROLE_PROOF_READER,
      roleAdmin: ROLE_SYSTEM_ADMIN,

      projectItem: {},
      projectItemTasks: null,

      showGenDesc: false,
      showProofDesc: false,
      showQaDesc: false,

      genDescription: '',
      proofDescription: '',
      qaDescription: '',

      loadingTasks: true,

      query: {
        id: this.$route.params.id,
        page: 1,
        perPage: 10,
      },

      roles: {
        systemAdmin: ROLE_SYSTEM_ADMIN,
      },

      isEdit: false,
      editData: {
        name: '',
        dueDate: null,
      },

      currentUserData: null,
      sortByName: '',
      sortBy: '',
    };
  },
  computed: {
    projectFileUpload () {
      return this.checkPermissions('project', 'project-file-upload');
    },
    sortedTasks () {
      return this.projectItemTasks.sort((a, b) => {
        let modifier = 1;
        const sortedDir = this.sortBy == '' ? 'asc' : this.sortBy;

        if (sortedDir === 'desc') modifier = -1;
        if (a[this.sortByName] < b[this.sortByName]) return -1 * modifier;
        if (a[this.sortByName] > b[this.sortByName]) return 1 * modifier;
        return 0;
      });
    },
  },
  created () {
    this.$store.dispatch('SHOW_PRELOADER', true);
    this.getProjectItem().finally(() => {
      this.$store.dispatch('SHOW_PRELOADER', false);
    });
  },
  methods: {
    getProjectItem () {
      return Api.projects
        .getProject(this.$route.params.id)
        .then((response) => {
          if (response.data.Status) {
            this.projectItem = response.data.Data;

            this.editData.name = this.projectItem.ProjectName;
            this.showDescriptions();
            this.getProjectItemTasks();
          } else {
            this.$router.push('/404');
          }
        });
    },

    showDescriptions () {
      if (this.projectItem.GenDescription !== null) {
        this.showGenDesc = 'text';

        var parseGenDescription = this.parseString(this.projectItem.GenDescription, 30);
        if (parseGenDescription != '') {
          this.genDescription = parseGenDescription;
          this.$set(this.projectItem, 'ShortGenDescription', parseGenDescription);
        }
      }

      if (this.projectItem.PRDescription !== null) {
        this.showProofDesc = 'text';

        var parseProofDescription = this.parseString(this.projectItem.PRDescription, 30);
        if (parseProofDescription != '') {
          this.proofDescription = parseProofDescription;
          this.$set(this.projectItem, 'ShortProofDescription', parseProofDescription);
        }
      }

      if (this.projectItem.QADescription !== null) {
        this.showQaDesc = 'text';

        var parseQaDescription = this.parseString(this.projectItem.QADescription, 30);
        if (parseQaDescription != '') {
          this.qaDescription = parseQaDescription;
          this.$set(this.projectItem, 'ShortQaDescription', parseQaDescription);
        }
      }
    },

    sortingColumns (nameSort) {
      this.sortByName = nameSort;
      if (this.sortBy === '') {
        this.sortBy = 'asc';
      } else if (this.sortBy === 'asc') {
        this.sortBy = 'desc';
      } else if (this.sortBy === 'desc') {
        this.sortBy = 'asc';
      }
    },

    getProjectItemTasks () {
      Api.projects
        .getProjectTask(this.query)
        .then((data) => {
          if (data.data.Status) {
            this.projectItemTasks = data.data.Data.map((value, ix) => {
              value.LanguageName = value.TargetLanguage.Country;
              value.StatusName = value.StepData.Name;
              value.OrderIx = ix + 1;
              return value;
            });
            this.responseData = data.data;

            this.diffTimeTasks();
            this.setCurrentUser();
          }

          this.loadingTasks = false;
        });
    },

    downloadFileHolder (id, name) {
      Api.tasks
        .downloadFile(id)
        .then((response) => {
          if (response.data.Status) {
            this.donwloadFileOnLink(response.data.Data, name);
          } else {
            this.$root.$emit('notification', {
              message: response.data.Message,
              type: 'error',
              show: true,
            });
          }
        });
    },

    /**
         * Delete attached files
         *
         * @param {Number} id
         */
    deleteAttachedFile (id) {
      Api.projects
        .removeFiles(`${this.$route.params.id}/${id}`)
        .then((response) => {
          if (response.data.Status) {
            this.projectItem.AdditionalPRData.Attachments = this.projectItem.AdditionalPRData.Attachments.filter((file) => file.AttachGUID !== id);

            this.$root.$emit('notification', {
              message: 'File was deleted',
              type: 'info',
              show: true,
            });
          }
        });
    },

    handleFileUpload (event) {
      const file = event.target.files[0];
      const formData = new FormData();

      if (this.projectItem) {
        formData.append('attach', file);

        Api.projects
          .uploadFile({
            id: this.projectItem.ID,
            file: formData,
          })
          .then((data) => {
            if (data.data.Status) {
              this.$root.$emit('notification', {
                message: data.data.Message,
                type: 'info',
                show: true,
              });
              this.getProjectItem(this.$route.params.id);
            } else {
              this.$root.$emit('notification', {
                message: data.data.Message,
                type: 'error',
                show: true,
              });
            }
          });
      }
    },

    diffTimeTasks () {
      this.projectItemTasks.forEach((item) => {
        const projectItemDueDate = moment(this.projectItem.DueDate);
        const itemDueData = moment(item.DueDate);
        const delay = moment.duration(itemDueData.diff(projectItemDueDate));
        this.$set(item, 'Delay', {
          days: delay.days(),
          hours: delay.hours(),
        });
      });
    },

    sendPage (page) {
      this.query.page = page;
      this.getProjectItemTasks();
    },

    setCurrentUser () {
      this.projectItem.AdditionalPRData.ProjectAccessData.forEach((item) => {
        if (item.Role == 'Project Manager') {
          this.currentUserData = item;
        }
      });
    },

    uploadTaskHolder () {
      const sendParams = {
        id: this.projectItem.ID,
        params: {
          name: this.editData.name,
          dueDate: this.$filters.formatUnix(this.editData.dueDate) || this.projectItem.DueDate,
          GenDescription: this.projectItem.GenDescription,
          PRDescription: this.projectItem.PRDescription,
          QADescription: this.projectItem.QADescription,
        },
      };

      Api.projects
        .update(sendParams)
        .then((response) => {
          if (response.data.Status) {
            this.showDescriptions();
            this.$root.$emit('notification', {
              message: 'Project was updated!',
              type: 'info',
              show: true,
            });

            this.projectItem.ProjectName = sendParams.params.name;
            this.projectItem.DueDate = sendParams.params.dueDate;
            this.isEdit = false;
          } else {
            this.$root.$emit('notification', {
              message: response.data.Message,
              type: 'error',
              show: true,
            });
          }
        });
    },

  },
};
